<div class="position-absolute" *ngIf="loading">
    <app-loading *ngIf="loading"></app-loading>
</div>

<div
    class="sidebar-panel"
    fxLayout="column"
    *ngIf="productList?.length && !loading"
>
    <div
        class="close-btn-sidebar"
        [ngClass]="lang == 'ar' ? 'close-btn-sidebar-ar' : ''"
    >
        <a
            href="javascript:void(0)"
            (click)="embryoService.paymentSidenavOpen = false"
        >
            <mat-icon class="material-icons"> close </mat-icon>
        </a>
    </div>
    <nav class="app-side-nav">
        <div class="">
            <div class="side-cart-head p-5 mb-3">
                <div class="mb-3">
                    <mat-icon class="material-icons"> shopping_cart </mat-icon>
                </div>
                <h5
                    *ngIf="
                        productList && productList?.length;
                        else elseCartBlock
                    "
                >
                    {{ "checkout.youHave" | translate }}
                    {{ productList?.length }}
                    {{ "checkout.itemsInYourCart" | translate }}
                </h5>
                <ng-template #elseCartBlock>
                    <div class="section-gap-lg text-center">
                        <div class="mb-4">
                            <img  loading="lazy" 
                                src="assets/images/empty-cart.png"
                                height="128"
                                width="128"
                                   alt="cart-empty"
                            />
                        </div>
                        <h4>{{ "checkout.cartEmpty" | translate }}</h4>
                        <a href="javascript:void(0);" class="primary-color">{{
                            "checkout.goForShopping" | translate
                        }}</a>
                    </div>
                </ng-template>
            </div>
            <div class="position-relative" *ngIf="productlistcopyed?.length">
                <div class="side-cart-wrapper">
                    <div
                        class="side-cart-list px-3"
                        *ngFor="let product of productlistcopyed"
                    >
                        <div fxLayoutAlign="center center">
                            <div
                                fxFlex.xs="25"
                                fxFlex.sm="25"
                                fxFlex.md="25"
                                fxFlex.lg="25"
                                fxFlex.xl="25"
                            >
                                <img  loading="lazy" 
                                    style="max-height: 150px;"
                                    [src]="product?.image"
                                    onError="src='./assets/images/placeholder200.jpg';"
                                    default="./assets/images/placeholder200.jpg"
                                    width="80"
                                       alt="cart img"
                                />
                            </div>
                            <div
                                fxFlex.xs="55"
                                fxFlex.sm="55"
                                fxFlex.md="55"
                                fxFlex.lg="55"
                                fxFlex.xl="55"
                                class="px-3"
                            >
                                <h6 class="mb-1">{{ product?.name }}</h6>
                                <p class="mb-0">
                                    <span *ngIf="product?.amount"
                                        >{{
                                            "productDetails.quantity"
                                                | translate
                                        }}: {{ product?.amount }}</span
                                    ><br />
                                    <ng-container
                                        *ngIf="
                                            product?.brand?.name &&
                                            environmentVariables?.SHOW_BRAND_ON_PRODUCT
                                        "
                                    >
                                        <span>
                                            {{
                                                "productDetails.brand"
                                                    | translate
                                            }}:
                                            {{
                                                lang == "en"
                                                    ? product?.brand?.name
                                                    : product?.brand?.name_ar
                                            }}
                                        </span>
                                    </ng-container>
                                    <br />

                                    <span
                                        [ngClass]="
                                            product?.discount_price !== null ||
                                            exclusiveLable
                                                ? 'line-through price-value-before-discount'
                                                : ''
                                        "
                                        >{{ "checkout.price" | translate }}:
                                        {{ product?.price | number: "1.2-2" }}
                                        {{
                                            lang == "en"
                                                ? environmentVariables?.CURRENCY_CODE_EN
                                                : environmentVariables?.CURRENCY_CODE_AR
                                        }}
                                    </span>

                                    <!--   <span
                                        class="d-flex payment-with-discount-container"
                                        *ngIf="product?.discount_price !== null"
                                        style="color: var(--brand-color)"
                                    >
                                        <div
                                            class="discount-method-information"
                                            *ngIf="
                                                product?.payment_methods_discount_name_en
                                            "
                                        >
                                            <p>i</p>
                                            <div class="hover-info">
                                                {{
                                                    lang == "en"
                                                        ? product?.payment_methods_discount_name_en
                                                        : product?.payment_methods_discount_name_ar
                                                }}
                                            </div>
                                        </div>
                                        </span
                                    ><br />

                                    <span
                                        *ngIf="product?.discount_price !== null"
                                        style="color: var(--brand-color)"
                                    >
                                        {{ "checkout.discount" | translate }}:
                                        {{ product?.discount_price | number }}
                                        {{
                                            lang == "en"
                                                ? environmentVariables?.CURRENCY_CODE_EN
                                                : environmentVariables?.CURRENCY_CODE_AR
                                        }}
                                    </span> -->

                                    <span
                                        class="d-flex payment-with-discount-container"
                                        *ngIf="
                                            product?.discount_price !== null ||
                                            (product?.exclusive_price &&
                                                exclusiveLable)
                                        "
                                        [ngClass]="{
                                            'text-primary':
                                                !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                            'price-value-after-discount':
                                                environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR
                                        }"
                                    >
                                        <!-- style="color: var(--brand-color)" -->

                                        <span class="no-overflow"
                                            >{{
                                                exclusiveLable &&
                                                product.exclusive_price
                                                    ? ("checkout.exclusivePrice"
                                                      | translate)
                                                    : ("checkout.discount"
                                                      | translate)
                                            }}:
                                            <span class="no-overflow"
                                                >{{
                                                    exclusiveLable &&
                                                    product.exclusive_price
                                                        ? product.exclusive_price
                                                        : (product?.discount_price
                                                          | number: "1.2-2")
                                                }}
                                                {{
                                                    lang == "en"
                                                        ? environmentVariables?.CURRENCY_CODE_EN
                                                        : environmentVariables?.CURRENCY_CODE_AR
                                                }}
                                            </span>
                                        </span>
                                        <div
                                            class="discount-method-information"
                                            *ngIf="
                                                product?.payment_methods_discount_name_en
                                            "
                                        >
                                            <p>i</p>
                                            <div class="hover-info">
                                                {{
                                                    lang == "en"
                                                        ? product?.payment_methods_discount_name_en
                                                        : product?.payment_methods_discount_name_ar
                                                }}
                                            </div>
                                        </div>
                                    </span>

                                    <span
                                        [hidden]="
                                            product.commission_amount == 0 ||
                                            product.commission_amount == null
                                        "
                                        *ngIf="user?.is_affiliate"
                                        class="commission-amount"
                                    >
                                        {{ "orders.commission" | translate }}
                                        {{
                                            product?.commission_amount
                                                | number: "1.2-2"
                                        }}
                                        {{
                                            lang == "en"
                                                ? environmentVariables?.CURRENCY_CODE_EN
                                                : environmentVariables?.CURRENCY_CODE_AR
                                        }}
                                    </span>
                                    <ng-container
                                        *ngIf="
                                            environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS &&
                                            product?.product_variants_options
                                                ?.length > 0
                                        "
                                    >
                                        <p
                                            class="mb-0"
                                            *ngFor="
                                                let options of product?.product_variants_options
                                            "
                                        >
                                            <span class="size">
                                                {{ options?.option?.name }}:
                                                {{ options?.values[0]?.name }}
                                            </span>
                                        </p>
                                    </ng-container>
                                </p>

                                <p
                                    class="mat-cell text-primary"
                                    *ngIf="
                                        (!product.in_stock ||
                                            product.stock == 0) &&
                                        product.active &&
                                        product.stock != null
                                    "
                                    translate
                                >
                                    {{ "orders.outOfStock" | translate }}
                                </p>
                                <p
                                    class="mat-cell text-primary"
                                    *ngIf="
                                        !product.active ||
                                        product?.stock == null
                                    "
                                    translate
                                >
                                    {{ "orders.notAvailable" | translate }}
                                </p>
                            </div>

                            <div
                                fxFlex.xs="20"
                                fxFlex.sm="20"
                                fxFlex.md="20"
                                fxFlex.lg="20"
                                fxFlex.xl="20"
                                class="side-cart-actions text-center px-2"
                            >
                                <!-- <a
                                    href="javascript:void(0)"
                                    (click)="removeProduct(product)"
                                >
                                    <mat-icon class="material-icons">
                                        remove_shopping_cart
                                    </mat-icon>
                                </a> -->
                                <a
                                    *ngIf="product.in_stock && product.active"
                                    [routerLink]="['/' + lang + '/cart']"
                                    (click)="
                                        embryoService.paymentSidenavOpen = false
                                    "
                                >
                                    <mat-icon class="material-icons">
                                        edit
                                    </mat-icon>
                                </a>
                            </div>
                        </div>
                        <hr class="spacer" />
                    </div>
                    <div class="px-3 text-right">
                        <!-- subtotal -->
                        <div>
                            <p>{{ "orders.subtotal" | translate }}</p>
                            <span fxFlex></span>
                            {{ calculateTotalPrice() | number: "1.2-2" }}
                            {{
                                lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                            }}
                        </div>

                        <!-- shipping -->
                        <div *ngIf="embryoService?.deliveryFees >= 0">
                            <p>{{ "checkout.shipping" | translate }}</p>
                            <span fxFlex></span>
                            <span *ngIf="embryoService?.deliveryFees == 0">
                                {{ "checkout.freeDelivery" | translate }}
                            </span>
                            <span *ngIf="embryoService?.deliveryFees !== 0">
                                +{{
                                    embryoService?.deliveryFees
                                        | number: "1.2-2"
                                }}
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }}
                            </span>
                        </div>
                        <!-- discount -->
                        <div
                            *ngIf="
                                embryoService?.promoObject &&
                                embryoService?.promoObject?.discount > 0
                            "
                        >
                            <div
                                *ngIf="
                                    !embryoService?.promoObject?.free_delivery
                                "
                            >
                                <p>{{ "orders.discount" | translate }}</p>
                                <span fxFlex></span>
                                - {{ discount | number: "1.2-2" }}
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }}
                            </div>
                            <div
                                *ngIf="
                                    embryoService?.promoObject?.free_delivery
                                "
                            >
                                <p>{{ "orders.discount" | translate }}</p>
                                <span fxFlex></span>
                                -
                                {{ discount | number: "1.2-2" }}

                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }}
                            </div>
                        </div>

                        <!-- ---------loyalty------ -->
                        <div
                            *ngIf="
                                loyaltyData?.points > 0 &&
                                loyaltyData?.credit > 0 &&
                                loyaltyData?.redeemed
                            "
                        >
                            <p>
                                {{ "loyalty.points_discount" | translate }}
                                <!-- {{ "loyalty.points" | translate }} -->
                            </p>
                            <span fxFlex></span>
                            <span>
                                -
                                {{
                                    (getTotalPrice() - redeemAmount > 0
                                        ? redeemAmount
                                        : getTotalPrice() > 0
                                        ? getTotalPrice()
                                        : 0
                                    ) | number: "1.2-2"
                                }}
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }}
                            </span>
                        </div>

                        
                        <div
                            *ngIf="
                                wallet_data?.use_wallet &&
                                wallet_data?.balance > 0
                            "
                        >
                            <p>
                                {{ "account.wallet" | translate }}
                            </p>
                            <span fxFlex></span>
                            <span>
                                -
                                {{
                                    (wallet_data?.balance <
                                        getTotalPrice() - redeemAmount ||
                                    wallet_data?.balance ==
                                        getTotalPrice() - redeemAmount
                                        ? wallet_data?.balance
                                        : getTotalPrice() - redeemAmount > 0
                                        ? getTotalPrice() - redeemAmount
                                        : 0
                                    ) | number: "1.2-2"
                                }}
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }}
                            </span>
                        </div>

                        <hr class="spacer" />
                        <div class="mb-4">
                            <h4>{{ "orders.total" | translate }}</h4>
                            <span fxFlex></span>
                            <h4 *ngIf="!freeDeliveryStatus">
                                {{
                                    (getTotalPrice() -
                                        redeemAmount -
                                        walletAmount ==
                                        0 ||
                                    getTotalPrice() -
                                        redeemAmount -
                                        walletAmount >
                                        0
                                        ? getTotalPrice() -
                                          redeemAmount -
                                          walletAmount
                                        : 0
                                    ) | number: "1.2-2"
                                }}
                                <!-- {{ amount + embryoService?.deliveryFees }} -->
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }}
                                <span
                                    *ngIf="
                                        environmentVariables?.ENABLE_INCLUDING_VAT
                                    "
                                    class="inc-vat"
                                >
                                    {{ "IncVAT" | translate }}
                                </span>
                            </h4>
                            <h4 *ngIf="freeDeliveryStatus">
                                <!-- {{ getTotalPrice() | number }} -->
                                {{ amount | number: "1.2-2" }}
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }}
                            </h4>
                        </div>
                        <div
                            class="mb-4 checkout_notes"
                            *ngIf="
                                embryoService?.checkout_notes ||
                                embryoService?.checkout_notes_ar
                            "
                        >
                            <h6>
                                {{
                                    lang == "en"
                                        ? embryoService?.checkout_notes
                                        : embryoService?.checkout_notes_ar
                                }}
                            </h6>
                        </div>
                        <div
                            class="mb-4"
                            *ngIf="
                                user?.is_affiliate &&
                                calculateTotalCommission() != 0 &&
                                calculateTotalCommission() != null
                            "
                        >
                            <h4 class="commission-amount">
                                {{ "orders.TotalCommission" | translate }}
                            </h4>
                            <span fxFlex></span>
                            <h4 class="commission-amount">
                                {{
                                    calculateTotalCommission() | number: "1.2-2"
                                }}
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</div>
